var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMqa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8892,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 39.8892 24)",
    fill: "#B5D7FC",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.667,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 57.667 24)",
    fill: "#B5D7FC",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1114,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 22.1114 24)",
    fill: "#B5D7FC",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8892,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 39.8892 24)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.667,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 57.667 24)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.1114,
    cy: 24,
    rx: 17.7778,
    ry: 17.7778,
    transform: "rotate(90 22.1114 24)",
    stroke: "#18181B",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMqa);
export default __webpack_public_path__ + "static/media/mqa.118ff0251c51d115dde72735354a6b0d.svg";
export { ForwardRef as ReactComponent };